import { yupResolver } from '@hookform/resolvers/yup';
import { Dispatch, SetStateAction } from 'react';
import { FieldPath, useForm } from 'react-hook-form';

import { ModalStep } from 'partsOld/enums';

import CostManufacturerModalView from './CostManufacturerModalView';
import { costManufacturerSchema } from './costManufacturerSchema';
import { ICostManufacturerForm, ManufacturerType } from './types';

interface IProps {
  onSubmit: (obj) => void;
  setStep: Dispatch<SetStateAction<ModalStep>>;
}

const CostManufacturerModal = ({ onSubmit, setStep }: IProps) => {
  const { handleSubmit, setValue, watch } = useForm<ICostManufacturerForm>({
    resolver: yupResolver(costManufacturerSchema),
    defaultValues: { manufacturerType: ManufacturerType.MULTIPLE },
  });

  const [costStartDate, costEndDate, manufacturerType, manufacturer] = watch([
    'costStartDate',
    'costEndDate',
    'manufacturerType',
    'manufacturer',
  ]);

  const onChangeDate = (date, field: FieldPath<ICostManufacturerForm>) => {
    setValue(field, date);
  };

  const onChangeManufacturer = (value) => {
    setValue('manufacturer', value);
  };

  const onCheckboxChange = (value) => {
    setValue('manufacturer', null);
    setValue('manufacturerType', value);
  };

  const onNext = (data) => {
    onSubmit(data);
    setStep(ModalStep.COLUMNS_HEADERS);
  };

  return (
    <CostManufacturerModalView
      startDate={costStartDate}
      endDate={costEndDate}
      onChangeDate={onChangeDate}
      onCheckboxChange={onCheckboxChange}
      manufacturerType={manufacturerType}
      manufacturer={manufacturer}
      onChangeManufacturer={onChangeManufacturer}
      handleSubmit={handleSubmit}
      onNext={onNext}
    />
  );
};

export default CostManufacturerModal;
